// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__KRYou","footer":"ModalInfo_footer__2p2Ot"};